<div (click)="login()">
  <ng-content></ng-content>
</div>

<!-- <div (click)="go()">Google login</div> -->